// extracted by mini-css-extract-plugin
export default {"cardHead":"cardHead__ZVPey_","cardContent":"cardContent__yGS0o2"};